import axios from "axios";

export const getClients = async ({ query = {}, controller = null, excludeInterceptor = false }: any) => {	
	const params: any = {params : query, excludeInterceptor}
	if(controller?.signal){
		params.signal = controller.signal
	}

	try {
		const res: any = await axios.get("/clients", params);
		return res?.data ? res.data : [];
	} catch (e: any) {
		return [];
	}
};

export const getClient = async ({ data, controller = null}: any) => {	
	try {
		const res: any = await axios.get(`/clients/${data?.id}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const createClient = async ({ create }: any) => {
	try {
		const res: any = await axios.post(`/clients`, create);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const updateClient = async ({ data, update }: any) => {
	try {
		const res: any = await axios.put(`/clients/${data?.id}`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};


export const deleteClient = async ({ data, update }: any) => {
	try {
		const res: any = await axios.delete(`/clients/${data?.id}`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

// Reactivate a deactivated client. The mirror of deleteClient, which
// despite its name deactivates rather than deletes.
export const reactivateClient = async ({ data }: any) => {
	try {
		const res: any = await axios.post(`/clients/${data?.id}/reactivate`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const resyncClient = async ({ data }: any) => {
	try {
		const res: any = await axios.post(`/clients/${data?.id}/resync`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

// Client Detail Overview tab (MASTER_PLAN.md §3.9 #13 remainder).
// See docs/maintenance-module/design/OVERVIEW_TAB.md §2 for the shape.
// excludeInterceptor: true — a transient failure on either of these
// (including the route simply not being deployed to an environment yet)
// must not trip the app-wide 404/403 error state in App.tsx, which
// blanks the entire SPA to NotFoundPage regardless of which widget
// failed. Both functions already degrade gracefully to an empty state
// in their catch blocks, so isolating the failure here is safe.
export const getClientOverview = async (clientId: string) => {
	const config: any = { excludeInterceptor: true };
	try {
		const res: any = await axios.get(`/clients/${clientId}/overview`, config);
		return res?.data ? res.data : null;
	} catch (e: any) {
		return null;
	}
};

export const getClientActivity = async (
	clientId: string,
	{ limit, before }: { limit?: number; before?: string } = {},
) => {
	const config: any = { params: { limit, before }, excludeInterceptor: true };
	try {
		const res: any = await axios.get(`/clients/${clientId}/activity`, config);
		return res?.data ? res.data : { items: [], hasMore: false };
	} catch (e: any) {
		return { items: [], hasMore: false };
	}
};

// Client Admin Company Settings
export const getMyClientCompany = async () => {
	try {
		const res: any = await axios.get(`/clients/my-company`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const updateMyClientCompany = async ({ update }: any) => {
	try {
		const res: any = await axios.put(`/clients/my-company`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};


